import { getPath } from "./utils";

export function checkLimitExceeded({ activeSessionCount, maxSessionsPerUser }) {
    return activeSessionCount > parseInt(maxSessionsPerUser)
}

export function isActiveSession() {
    return window.localStorage.getItem("activeSession");
}

export function removeSessionFlag() {
    window.localStorage.removeItem("activeSession");
}

export function addSessionFlag() {
    window.localStorage.setItem("activeSession", true)
}

export async function getActiveSessionCount({ sketchesHost }) {
    const url = getPath({ sketchesHost, relativePath: '/api/auth/v1/sessions' })
    const { count } = await (await fetch(url)).json();
    return count
}

export function navigateToSessionExeededPage({ sketchesHost, whiteListedUrlParams }) {
    const isSessionExcededPage = window.location.pathname.includes('/session-exceeded');
    if (!isSessionExcededPage) {
        global?.localStorage?.setItem('sessionExceededRedirectUrl', window?.location?.href);
        window.location.href = getPath({
            sketchesHost,
            relativePath: '/session-exceeded',
            injectCustomParams: true,
            whiteListedUrlParams
        });
    }
}